<template>
  <aside>
    <!--    <JoinEvent />-->
    <MainMenu/>
    <AdminPanel v-if="userRoleName === 'admin' || userRoleName === 'superadmin'"/>
    <ComingSoon/>
    <SupportMenu/>
  </aside>
</template>

<script>

import JoinEvent from './ButtonJoin'
import MainMenu from './MainMenu'
import AdminPanel from './AdminPanel'
import ComingSoon from './ComingSoonMenu'
import SupportMenu from './SupportMenu'

export default {
  name: 'EventMenu',
  components: {
    MainMenu,
    AdminPanel,
    ComingSoon,
    SupportMenu,
  },

  props: {
    userRoleName: String,
  },

  data () {
    return {
      activeMainMenu: 'exhibition',
    }
  },
}
</script>


<style lang="scss">
.menu-main {
  margin-top: 40px;

  &__title {
    margin-bottom: 16px;
  }

  &__list {
    //margin-top: 20px;
  }

  a.menu-main__elem {
    color: #777577;

    &.router-link-exact-active {
      color: #ffffff;
      cursor: default;

      svg {
        color: #BE9555;
      }

      &::before {
        position: absolute;
        height: 20px;
        width: 3px;
        content: '';
        left: 0;
        background: linear-gradient(135.79deg, #FFD88D 25.58%, #AA7E4A 66.87%);
        box-shadow: 1px 0px 15px rgba(218, 176, 112, 0.6);
      }
    }
  }

  &__elem {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
    color: #3e3e3e;
    svg.logout {
      opacity: 0.5;
    }
    a, span {
      padding: 0 12px;
    }
  }

  &__contacts {
    margin-top: 40px;

    a:first-of-type {
      margin-top: 10px;
      margin-bottom: 10px;
    }

    .link {
      display: block;
      color: #ffffff;
      opacity: 0.7;
    }



  }

  .rtl & {
    a.menu-main__elem {
      &.router-link-exact-active {
        &::before {
          left: auto;
          right: 0;
        }
      }
    }
    .link__phone {
      direction: ltr;
      text-align: right;
    }
  }
}
</style>
